/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BehaviorGoalModel } from '../../models/behavior-goal-model';

export interface GetPatientBehaviorGoals$Params {
  patientID?: number;
}

export function GetPatientBehaviorGoals(http: HttpClient, rootUrl: string, params?: GetPatientBehaviorGoals$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BehaviorGoalModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientBehaviorGoals.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BehaviorGoalModel>>;
    })
  );
}

GetPatientBehaviorGoals.PATH = '/api/Supervisor/GetPatientBehaviorGoals';
